module.exports = __webpack_public_path__ + "static/media/ma.08d13fab.svg";